export default __webpack_public_path__ + "static/media/Group1198101.ea02a038.svg";